<template>
  <v-card
    tag="article"
    class="article-card-default"
    :to="to"
    color="transparent"
    flat
    tile
  >
    <img
      :src="files + img + '?resize=1&w=300'"
      :alt="title"
      loading="lazy"
      @error="invalidImage = true"
    />
    <div
      class="
        article-card-default-content
        d-flex
        flex-column
        justify-start
        align-start
      "
    >
      <h2 class="text-body-2 mt-2 mb-1 font-weight-black">{{ title }}</h2>
      <time
        class="text-body-2 grey--text text--darken-2"
        v-if="localeDate"
        :datetime="ISODate"
      >
        {{ localeDate }}
      </time>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    ISODate: {
      type: String,
      required: true,
    },
    localeDate: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    invalidImage: false,
  }),
};
</script>

<style>
.article-card-default {
  display: grid;
  grid-template-columns: auto;
}

.article-card-default img {
  aspect-ratio: 16 / 9;
  width: 100%;
  object-fit: cover;
}
</style>
